import { Spacing } from 'UI'
import { createUseStyles } from 'react-jss'
import CourseDescription from '../CourseDescription'
import VideoThumbnail from './VideoThumbnail'
import style from './style'
import LearningPaths from './LearningPaths'
import { projectSectionFeature, showLearningPath } from 'constants/'
import Projects from '../Projects'

const useStyles = createUseStyles(style)

export default ({ loading, scrollToPricing, projectDetails, projectDescription, ProfileType, courseTitle, Tags }) => {
  const { root } = useStyles()

  return (
    <div className={root}>
      <VideoThumbnail />
      {showLearningPath ? <LearningPaths /> : null}
      {
        projectSectionFeature
          ? <Projects
              courseTitle={courseTitle}
              projectDetails={projectDetails}
              projectDescription={projectDescription}
              ProfileType={ProfileType}
              tags={Tags}
              scrollToPricing={scrollToPricing}
              loading={loading}
              margin={Spacing(0, 0, 5, 0)}
              padding={Spacing(5)}
              paper
            />
          : null
        }
      <CourseDescription descriptionTextHeight={500} loading={loading} noExpand collapsable />
    </div>
  )
}
